import { render, staticRenderFns } from "./OrdersIcon.vue?vue&type=template&id=293b1925&"
import script from "./OrdersIcon.vue?vue&type=script&lang=js&"
export * from "./OrdersIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports